// === WISHLIST LOCALSTORAGE ===

// Obtener wishlist del localStorage
function getWishlist() {
  return JSON.parse(localStorage.getItem("wishlist")) || [];
}

// Guardar wishlist
function saveWishlist(list) {
  localStorage.setItem("wishlist", JSON.stringify(list));
}

// Agregar o quitar producto
function toggleWishlist(productId) {
  let list = getWishlist();

  if (list.includes(productId)) {
    list = list.filter(id => id !== productId);
  } else {
    list.push(productId);
  }

  saveWishlist(list);
  updateWishlistCount();
  updateWishlistIcons();
}

// Actualizar número en el header
function updateWishlistCount() {
  const count = getWishlist().length;
  const badge = document.querySelector(".wishlist-count");
  if (badge) badge.textContent = count;
}

// Cambiar icono si el producto está en wishlist
function updateWishlistIcons() {
  const list = getWishlist();
  document.querySelectorAll("[data-wishlist-id]").forEach(btn => {
    const id = btn.getAttribute("data-wishlist-id");
    if (list.includes(id)) {
      btn.classList.add("in-wishlist");
    } else {
      btn.classList.remove("in-wishlist");
    }
  });
}

// Listeners
document.addEventListener("click", function(e) {
  if (e.target.matches("[data-wishlist-id]")) {
    e.preventDefault();
    const productId = e.target.getAttribute("data-wishlist-id");
    toggleWishlist(productId);
  }
});

// Inicializar
document.addEventListener("DOMContentLoaded", () => {
  updateWishlistCount();
  updateWishlistIcons();
});
